import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import CardUserService from '../services/CardUserService';
class MobileUserRoleDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardUserService());
        this.state = {
            accountRoleOptions: [
                {enumValue: 'DRIVER', label: props.t('AccountRole.DRIVER')},
                {enumValue: 'ADMIN', label: props.t('AccountRole.ADMIN')},
            ],
            accountRole: props.accountRole ? props.accountRole : 'DRIVER',
            carRegistration: props.carRegistration ? props.carRegistration : '',
            personName: props.personName ? props.personName : '',
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        const {accountRole, personName, carRegistration} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.blockUi();
            this.service
                .updateRole({accountRole, personName, carRegistration, phoneNumber: this.props.phoneNumber})
                .then((response) => {
                    this.unblockUi();
                    if (this.props.handleSuccess) {
                        this.props.handleSuccess({accountRole, personName, carRegistration});
                    }
                })
                .catch((err) => {
                    this.unblockUi();
                    if (this.props.handleError) {
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <InputDropdownComponent
                        id='accountRole-dialog'
                        name='accountRole'
                        label={t('cards.roleName')}
                        colClass='col-12 col-sm-4'
                        options={this.state.accountRoleOptions}
                        value={this.state.accountRole}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        validators='required'
                        validator={this.validator}
                        renderRequired
                        stateField=''
                        optionLabel='label'
                        enumMode
                        enumName='AccountRole'
                        optionValue='enumValue'
                        dataKey='enumValue'
                    />
                    <InputTextComponent
                        id='personName-dialog'
                        name='personName'
                        label={t('cards.personName')}
                        colClass='col-12 col-sm-4'
                        value={this.state.personName}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        validators='not_required|alpha_space_dash|max:64'
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                        validator={this.validator}
                        stateField=''
                        forceUpperCase
                        max={64}
                    />
                    <InputTextComponent
                        id='carRegistration-dialog'
                        name='carRegistration'
                        label={t('cards.carRegistration')}
                        colClass='col-12 col-sm-4'
                        value={this.state.carRegistration}
                        viewMode={'EDIT'}
                        onChange={this.handleChange}
                        validators='not_required|alpha_num|max:10'
                        keyfilter={/^[A-Z0-9]*$/i}
                        validator={this.validator}
                        stateField=''
                        forceUpperCase
                        max={10}
                    />
                </div>
            </React.Fragment>
        );
    }
}

MobileUserRoleDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

MobileUserRoleDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    phoneNumber: PropTypes.string.isRequired,
};

export default withTranslation()(MobileUserRoleDialog);
